import React, { useState, useEffect, useRef } from 'react';
import { STATS } from '../data/stats';

function useCountUp(target, duration, shouldStart) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!shouldStart) return;
    let start = 0;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, shouldStart]);

  return count;
}

function StatItem({ stat }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const count = useCountUp(stat.numericValue, 1500, visible);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="stats-item" ref={ref}>
      <div className="stat-number">
        {visible ? `${count.toLocaleString()}${stat.suffix}` : stat.value}
      </div>
      <div className="stats-label">{stat.label}</div>
    </div>
  );
}

export default function StatsBar() {
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">KOA DETAILING 실적</h2>
        <p className="section-subtitle">
          숫자로 증명하는 프리미엄 세차
        </p>
        <div className="stats-bar">
          {STATS.map((stat, i) => (
            <StatItem key={i} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
}
